import {createSlice} from '@reduxjs/toolkit';
import {fetchCustomer} from '../actions/CustomerActions';

// ---- import from local actions ----

const CustomerSlice = createSlice({
  name: 'customer',
  initialState: {
    customerSelection: {
      data: [],
      status: 'idle',
      error: '',
      loading: false,
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomer.pending, (state) => {
        state.customerSelection.status = 'loading';
      })
      .addCase(fetchCustomer.fulfilled, (state, action) => {
        state.customerSelection.status = 'idle';
        state.customerSelection.data = action.payload.result;
      })
      .addCase(fetchCustomer.rejected, (state, action) => {
        state.customerSelection.status = 'rejected';
        state.customerSelection.error = action.error.message;
      });
  },
});

export const setCurrentCustomerData = (state) =>
  state.customer.customerSelection.currentCustomerData;
export default CustomerSlice.reducer;
